(function () {
  "use strict";

  // Find trademarks in known sections and superscript
  function replaceRegisteredTrademarks() {
    const bannerContent = document.querySelectorAll(".banner__content");
    const multiColumnCards = document.querySelectorAll(
      ".multicolumn-card__info"
    );
    const heroes = document.querySelectorAll(".hero__content");
    const cardsContent = document.querySelectorAll(".card__content");
    const multiRows = document.querySelectorAll(".media-text__text");
    const imageWithText = document.querySelectorAll(
      ".image-with-text__content"
    );
    const richTextBlocks = document.querySelectorAll('.rich-text__blocks');
    const productTeaserMetaobjects = document.querySelectorAll('.product-teaser-metaobj');
    const clickableVideoBanners = document.querySelectorAll('.clickable-video-banner__text');
    const items = [
      ...multiColumnCards,
      ...heroes,
      ...cardsContent,
      ...multiRows,
      ...imageWithText,
      ...bannerContent,
      ...richTextBlocks,
      ...productTeaserMetaobjects,
      ...clickableVideoBanners
    ];

    if (items.length > 0) {
      items.forEach((item) => {
        const input = item.outerHTML.replace(/®/g, "<sup>®</sup>");
        item.outerHTML = input;
      });
    }
  }

  function addClickEventsToMultiColumnImages() {
    const columns = Array.from(document.querySelectorAll('.multicolumn-list[data-link-images="true"] .multicolumn-card'));
    for (const column of columns) {
      const imageWrapper = column.querySelector('.multicolumn-card__image-wrapper');
      const link = column.querySelector('.link');
      if (!link || !imageWrapper) continue; // Skip column if no link or image.
      const href = link.href;
      imageWrapper.addEventListener('click', () => {
        window.location.href = href;
      })
      
    }
  }

  document.addEventListener("DOMContentLoaded", function () {
    replaceRegisteredTrademarks();
    addClickEventsToMultiColumnImages();
  });
})();
